//---------------------------------------------

//  --  トップ処理

//---------------------------------------------
export default class topManager {
    constructor(effect) {

        this.scroll={};

        this.status = {
            kv : true
        }

        // Safariでボタンが被る用
        this.$targetBtn;
        this.$target;

        // sidenavとkv被る用
        this.$targetSideNav;
        this.$targetArea;

    }
    init(scroll){
        this.$targetBtn = document.querySelectorAll('#p-stationmap .c-btn');
        this.$target = document.getElementsByClassName('js-btn-line');
        this.$targetSideNav = document.getElementById("c-sidebtn");
        this.$targetArea = document.getElementById("p-network-stage");

        for(let i = 0; i < this.$targetBtn.length; i++) {
            this.$targetBtn[i].addEventListener("mouseout", () => {
                this.hoverOut(i);
            });
        }

        this.$targetArea.addEventListener("mouseover", () => {
            this.hoverOnKv();
        });
        this.$targetArea.addEventListener("mouseout", () => {
            this.hoverOutKv();
        });
        this.scroll = scroll;

    }
    hoverOut(index) {
        this.$target[index].setAttribute('style', 'transform:translateZ(0);height:100%;position:absolute;top:0;left:0;width:100%;');
    }
    hoverOnKv() {
        this.$targetSideNav.style.pointerEvents = "none";
    }
    hoverOutKv() {
        this.$targetSideNav.style.pointerEvents = "auto";
    }
    render(){
    }
    wheel(delta){
        // console.log(delta,this.scroll.inc)

        if(this.scroll.inc<this.scroll.h){
            if(delta<0){
                /* コンテンツに移動 */
                if(this.status.kv){
                    this.status.kv = false;
                    TweenLite.to(window, 0.3,{scrollTo:{y:this.scroll.h,autoKill:false}});
                }
            }
        }else{
            if(delta>0){
                /* コンテンツに移動 */
                if(!this.status.kv){
                    this.status.kv = true;
                    TweenLite.to(window, 0.3,{scrollTo:{y:0,autoKill:false}});
                }
            }
        }


    }
}